// Markets page event definitions for analytics.

import type { EventDefinition } from './navigation';

export type MarketsPageViewedProperties = {
  path: string;
  locale: string;
};

export type MarketsSortChangedProperties = {
  sort: string;
  previousSort: string;
};

export type MarketsFilterChangedProperties = {
  filterType:
    | 'category'
    | 'location'
    | 'status'
    | 'outcomes'
    | 'volume'
    | 'prizePool'
    | 'liquidity'
    | 'backers'
    | 'traders'
    | 'createdAt'
    | 'creator'
    | 'marketCap'
    | 'holders'
    | 'change24h'
    | 'graduatedAt';
  value: string;
  previousValue: string;
};

export type MarketsCardClickedProperties = {
  marketPubkey: string;
  position: number;
  sort: string;
};

export type MarketsBookmarkToggledProperties = {
  marketPubkey: string;
  saved: boolean;
};

export type MarketsLoadMoreProperties = {
  page: number;
  sort: string;
};

export const MARKETS_PAGE_VIEWED: EventDefinition<MarketsPageViewedProperties> = {
  name: 'markets_page_viewed',
};

export const MARKETS_SORT_CHANGED: EventDefinition<MarketsSortChangedProperties> = {
  name: 'markets_sort_changed',
};

export const MARKETS_FILTER_CHANGED: EventDefinition<MarketsFilterChangedProperties> = {
  name: 'markets_filter_changed',
};

export const MARKETS_CARD_CLICKED: EventDefinition<MarketsCardClickedProperties> = {
  name: 'markets_card_clicked',
};

export const MARKETS_BOOKMARK_TOGGLED: EventDefinition<MarketsBookmarkToggledProperties> = {
  name: 'markets_bookmark_toggled',
};

export const MARKETS_LOAD_MORE: EventDefinition<MarketsLoadMoreProperties> = {
  name: 'markets_load_more',
};

export type MarketsSearchQueriedProperties = {
  query: string;
};

export const MARKETS_SEARCH_QUERIED: EventDefinition<MarketsSearchQueriedProperties> = {
  name: 'markets_search_queried',
};
